

























import { Vue, Component, Prop } from 'vue-property-decorator';
import AppBase from '../common/base';
import { ScatterPoint } from '../../model/api';

@Component
export default class Podium extends AppBase {
    @Prop() values: ScatterPoint[];
    @Prop() bgColors: string[];
    @Prop() labelsColor: string;
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/surveys/podium.vue